import { render, staticRenderFns } from "./CourseClassFreeSchedule.vue?vue&type=template&id=395192a8"
import script from "./CourseClassFreeSchedule.vue?vue&type=script&lang=js"
export * from "./CourseClassFreeSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports